export default __webpack_public_path__ + "static/media/advriest.53bc4cab.jpg";